import { Injectable, Injector  } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { HttpService } from './http.service';
import { TenantService } from './tenant.service';
import { MLService } from '../services/ml-service';
import { first, mergeMap } from 'rxjs/operators';

@Injectable()

export class AuthInterceptorService implements HttpInterceptor {
  constructor(private readonly injector: Injector, private readonly httpService: HttpService, private readonly tenantService: TenantService, public mlService: MLService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let finalTenantId:any;
    const injectTenant = this.injector.get(TenantService);
    let serviceTenant:any = injectTenant.getCurrentTenant();

    if (serviceTenant?.tenantId && serviceTenant.tenantId > 0) {
      finalTenantId = serviceTenant.tenantId;
    }
    
    request = request.clone({
      setHeaders: {
        tenantId: `${finalTenantId}`
      }
    })
    return next.handle(request);
  }
}
